import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import { clearOrders } from "../../redux/ordersSlice";
import { clearCart } from "../../redux/cartSlice";

const SettingsPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    // Clear all local storage items
    localStorage.removeItem("user");
    localStorage.removeItem("role");
    localStorage.removeItem("vendorId");
    
    // Clear all cookies
    const cookies = document.cookie.split(";");
    cookies.forEach((cookie) => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=" + window.location.hostname + ";path=/";
    });

    // Clear session storage
    sessionStorage.clear();

    // Clear Redux state
    dispatch(clearOrders());
    dispatch(clearCart());

    toast.success("Logged out successfully!");

    // Navigate to login page
    navigate("/login");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-blue-50 to-gray-100">
      <h1 className="text-3xl font-bold mb-6 text-gray-800">Settings</h1>
      <button
        onClick={handleLogout}
        className="bg-red-600 text-white py-3 px-6 rounded-xl shadow-lg hover:bg-red-700 transition"
      >
        Logout
      </button>
    </div>
  );
};

export default SettingsPage;
